<app-modal [shouldShowModal]="showModal" (closeModal)="closeQuebecModal()" [templateRef]="quebecModalRef">
</app-modal>
<ng-template #quebecModalRef>
  <div class="red-top">
  </div>
  <div class="bottom">
    <div class="banner-wrapper">
      <div class="banner" [ngStyle]="{'background-image': 'url(\'' + ( '/assets/landing_page/hero_image@3x.jpg' | staticp) + '\')' }">
      </div>
    </div>
    <div class="quebec-content">
      <div class="logo text-center full-width">
        <img src="{{'/assets/Ballon_Logotype_URL_RGB.svg' | staticp }}" [alt]="'quebec.logo' | translate">
      </div>
      <div class="sub-level text-center is-flex is-flex-column">
      <span translate="quebec.visit.french"></span>
      <span translate="quebec.visit.english"></span>
      </div>
      <div class="button-wrapper text-center">
        <a role="button" href="https://www.remax-quebec.com" target="_blank" rel="noopener" class="btn btn-primary btn-full-sized" translate="quebec.website"></a>
      </div>
    </div>
  </div>
</ng-template>
